<!--
  athWyCho.vue ( 1 step, mblElcSgn16 )
  - 인증선택화면
 -->
<template>
  <div id="wrap" class="wrap_layout">
    <!--Header [s]-->
    <Header type="type_intro" />
    <!--Header [e]-->
    <!-- Container [s] -->
    <div class="container">
      <div class="contents">
        <!-- Cotents Area [s]-->
        <div class="section">
          <p class="txt">
            안전한 가입을 위해 본인인지 확인하고 진행하겠습니다.<br />
            본인확인방법을 선택하세요.
          </p>
          <ul class="certify_option active">
            <li>
              <a type="button" class="type_phone" @click="athCho('cell')"
                ><span>휴대폰 인증</span></a
              >
            </li>
            <li>
              <a type="button" class="type_kakaotalk" @click="athCho('kakao')"
                ><span>카카오 인증</span></a
              >
            </li>
            <li>
              <a type="button" class="type_naver" @click="athCho('naver')"
                ><span>네이버 인증서</span></a
              >
            </li>
            <li>
              <a type="button" class="type_union" @click="athCho('union')"
                ><span>공동인증서 인증</span></a
              >
            </li>
            <li>
              <a type="button" class="type_bank" @click="athCho('fncAthdc')"
                ><span>금융 인증서</span></a
              >
            </li>
          </ul>
          <div class="btn_area" v-if="state.mode == 'development'">
            <button type="button" class="btn_main w100p" @click="pass">
              <span>인증패스</span></button
            ><!-- 기본 : disabled, 인증 끝난후 제거 -->
          </div>
        </div>
      </div>
    </div>
    <Footer @pass="pass" />
  </div>
</template>

<script>
// @ is an alias to /src
import { reactive, inject, onMounted } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import util from "@/common/util";
import { sessionUserInfo, load } from "@/common/sessionFactory";
import useDialog from "@/common/dialog";
import Header from "@/components/common/Header.vue";
import Footer from "@/components/common/Footer.vue";

export default {
  name: "cellAth",
  components: {
    Header,
    Footer,
  },

  setup() {
    const store = useStore();
    const router = useRouter();
    const dialog = useDialog(inject("$vfm"));

    // 세션 데이터 가져오기
    onMounted(async () => {
      await load();
      util.saveLog("009", "본인인증"); // 009 : 화면진입
      if (sessionUserInfo == null) {
        router.push({ name: "sessionExpired" });
        return;
      }

      store.commit("elcSgnInf/changeSgnTrnsFlag", false);
      store.commit("elcSgnInf/changeCmpltSalCompFlag", false);

      if (
        !util.isEmpty(sessionUserInfo.surrogateId) &&
        util.isNull(sessionUserInfo.prctrNo)
      ) {
        store.commit("elcSgnInf/isRpsMbl", true);
      } else {
        store.commit("elcSgnInf/isRpsMbl", false);

        if (sessionUserInfo.inqStdDt < state.currDate) {
          router.push({ name: "usePrdExpired" });
        }
      }
    });

    const state = reactive({
      currDate: util.formatDate(new Date(), "yyyymmdd"),
      mode: process.env.NODE_ENV,
    });

    const athCho = (type) => {
      switch (type) {
        case "cell":
          router.push({ name: "cellAth" });
          break;
        case "kakao":
          dialog.lyorPop("01/dialog/KkoAuthGuidMtt.vue").then(() => {
            router.push({ name: "kakaoAth" });
          });
          break;
        case "naver":
          dialog.lyorPop("01/dialog/NaverAuthGuidMtt.vue").then(() => {
            router.push({ name: "naverAth" });
          });
          break;
        case "union":
          router.push({ name: "jntAthdcAth" });
          break;
        case "fncAthdc":
          router.push({ name: "fncAthdc" });
          break;
      }
    };

    const pass = () => {
      router.push({ name: "ctrBasMttCnf" });
    };

    return {
      state,
      athCho,
      pass,
      load,
      sessionUserInfo,
    };
  },
};
</script>
